import type { StatusTone } from '@/components/core';
import { ReviewStatus } from '@/modules/performance/hr-review-core';

/** Outlined chip tone per legacy ReviewStatus (the reviews list). */
export const REVIEW_STATUS_TONE: Record<ReviewStatus, StatusTone> = {
  NotApplicable: 'muted',
  IsRequested: 'warning',
  IsForwarded: 'info',
  IsCompleted: 'success',
};

/** Badge colour per legacy ReviewStatus; NotApplicable steps are never shown. */
export const REVIEW_STATUS_VARIANT: Record<ReviewStatus, 'default' | 'secondary' | 'outline'> = {
  NotApplicable: 'outline',
  IsRequested: 'secondary',
  IsForwarded: 'outline',
  IsCompleted: 'default',
};

const REVIEW_STATUS_KEYS: Record<ReviewStatus, string> = {
  NotApplicable: 'NOT_APPLICABLE',
  IsRequested: 'REQUESTED',
  IsForwarded: 'FORWARDED',
  IsCompleted: 'COMPLETED',
};

export const reviewStatusKey = (status: ReviewStatus) => REVIEW_STATUS_KEYS[status];
